import React, { useId } from 'react';
import PropTypes from 'prop-types';
import { talkRatio } from './reviewData';

const duration = seconds => `${Math.floor(seconds / 60)}분 ${seconds % 60}초`;

// 예시 데이터: 발화 시간 기준
function exampleShare() {
    const totalSeconds = talkRatio.counselorSeconds + talkRatio.clientSeconds;
    const counselorPercent = Math.round(talkRatio.counselorSeconds / totalSeconds * 100);
    return {
        counselorPercent, clientPercent: 100 - counselorPercent,
        counselorDetail: duration(talkRatio.counselorSeconds), clientDetail: duration(talkRatio.clientSeconds),
        tag: '발화 시간 기준 · 예시',
        note: <>이 면담의 예시 기준: 상담자 {talkRatio.targetCounselor}% · 내담자 {talkRatio.targetClient}%<br />침묵을 제외한 전체 발화 시간 대비 비율입니다. OARS 비율·MITI 행동 빈도와 별도로 확인하는 학습 지표입니다.</>,
    };
}

// share를 넘기지 않으면 예시 데이터를 보여준다.
export default function TalkRatio({ share }) {
    const titleId = useId();
    const { counselorPercent, clientPercent, counselorDetail, clientDetail, tag, note } = share || exampleShare();

    return <article className="review-card review-talk" aria-labelledby={titleId}>
            <div className="review-row"><h2 id={titleId}>대화 점유율 (Talk Ratio)</h2><span className="review-tag">{tag}</span></div>
            <p>내담자가 자신의 이야기를 충분히 펼칠 수 있도록 대화의 균형을 살펴보세요.</p>
            <div className="talk-bar" aria-hidden="true"><span style={{ width: `${counselorPercent}%` }}>{counselorPercent}%</span><span style={{ width: `${clientPercent}%` }}>{clientPercent}%</span></div>
            <div className="review-row talk-labels"><span>상담자 <strong>{counselorPercent}%</strong> · {counselorDetail}</span><span>내담자 <strong>{clientPercent}%</strong> · {clientDetail}</span></div>
            <p className="ai-small">{note}</p>
        </article>;
}
TalkRatio.propTypes = {
    share: PropTypes.shape({
        counselorPercent: PropTypes.number.isRequired, clientPercent: PropTypes.number.isRequired,
        counselorDetail: PropTypes.string, clientDetail: PropTypes.string, tag: PropTypes.string, note: PropTypes.node,
    }),
};
